import React from "react"
import { FC } from "react"
import { Entity } from "../objects/Entity.interface"
import { Field } from "../objects/Field.interface";
import { Annotation } from '../objects/Annotation.interface';
import { AnnotationService } from "../services/Annotations.service";
import { basicFormatString, getDuplicateUniquesAnnotations } from "../tools/Utils";
import { DeleteForeverOutlined } from '@mui/icons-material';
import { PlaceNameStats } from "../objects/PlaceNameStats.interface";

interface ContextMenuEntityFieldsProps {
    entities: Entity[],
    entityId:number,
    fieldIndex:number,
    fieldSelected:number,
    annotation:Annotation,
    annotationList:Annotation[],
    menuFieldId:String,
    filterAnnotationsToSave: (annotations:Annotation[]) => Annotation[],
    closeContextMenu: () => void,
    refreshData: () => void,
    updateDocumentStats:() => void
}

const ContextMenu_EntityFields:FC<ContextMenuEntityFieldsProps> = ({entities, entityId, fieldIndex, fieldSelected, annotation, annotationList,menuFieldId, filterAnnotationsToSave,closeContextMenu, refreshData, updateDocumentStats}) => {

    const _annotationsService = new AnnotationService();
    var annotationsToSave:Annotation[] = [];



    function getEntityById(entityId:number):Entity|undefined{
        var entityFounded =  entities.find((entity) => entity.id == entityId);
        return entityFounded;
    }

    function getEntityFields(entityId:number):Field[]{
        var fields:Field[] = [];
        var entityFounded:Entity|undefined = getEntityById(entityId);
        if(entityFounded){
            fields = entityFounded.FieldList!;
            fields = filterSelectedField(annotation, fields);
        }
        return fields;
    }


    function setFirstFieldsToAnnotations(field:Field){
        if(annotationsToSave.length > 0){
            if(!annotation.isUniqueMode){
                annotationsToSave.forEach(annSelected => {
                    if(!annSelected.isUniqueMode){
                        annSelected = setFirstEntityFirstFieldData(annSelected, field);
                    }
                });
                updateBulkAnnotations(annotationsToSave);
            }else{
                var annnotationToUpdate = getDuplicateUniquesAnnotations(annotationsToSave,annotation);

                if(annnotationToUpdate.length > 0)
                {
                    annnotationToUpdate.forEach(annSelected => {
                        annSelected = setFirstEntityFirstFieldData(annSelected, field);
                    });
                    updateBulkAnnotations(annnotationToUpdate);
                }
            }


            

        }
    }

     function  setFirstEntityFirstFieldData(annSelected:Annotation, field:Field):Annotation{
        if(!annSelected.fieldsFirstEntity)
        {
            annSelected.fieldsFirstEntity = [];
        }

        if(annSelected.fieldsFirstEntity.length == 0){
            annSelected.fieldsFirstEntity.push(field.code);
        }
        else{
            annSelected.fieldsFirstEntity[0] =field.code;
        }

        return annSelected;
     }

    function setSecondFieldsToAnnotations(field:Field){
        if(annotationsToSave.length > 0){
            if(!annotation.isUniqueMode){
                annotationsToSave.forEach(annSelected => {
                    annSelected = setFirstEntitySecondFieldData(annSelected,field)
                });
            
                updateBulkAnnotations(annotationsToSave);
            }else
            {
                var annnotationToUpdate = getDuplicateUniquesAnnotations(annotationsToSave,annotation);

                if(annnotationToUpdate.length > 0)
                {
                    annnotationToUpdate.forEach(annSelected => {
                        annSelected = setFirstEntitySecondFieldData(annSelected, field);
                    });
                    updateBulkAnnotations(annnotationToUpdate);
                }
            }
        }
    }

    function setFirstEntitySecondFieldData(annSelected:Annotation, field:Field):Annotation{
        if(!annSelected.fieldsFirstEntity)
        {
            annSelected.fieldsFirstEntity = [];
        }

        if(annSelected.fieldsFirstEntity.length < 2){
            annSelected.fieldsFirstEntity.push(field.code);
        }
        else{
            annSelected.fieldsFirstEntity[1] =field.code;
        }
        return annSelected;
    }


    function setFirstFieldsSecond(field:Field){
        if(annotationsToSave.length > 0){
            if(!annotation.isUniqueMode){
            annotationsToSave.forEach(annSelected => {
                annSelected = setSecondEntityFirstFieldData(annSelected, field);
            });
            updateBulkAnnotations(annotationsToSave);
            }
            else{
                var annnotationToUpdate = getDuplicateUniquesAnnotations(annotationsToSave,annotation);

                if(annnotationToUpdate.length > 0)
                {
                    annnotationToUpdate.forEach(annSelected => {
                        annSelected = setSecondEntityFirstFieldData(annSelected, field);
                    });
                    updateBulkAnnotations(annnotationToUpdate);
                }
            }

        }
    }

    function setSecondEntityFirstFieldData(annSelected:Annotation, field:Field):Annotation{
        if(!annSelected.fieldsSecondEntity)
        {
            annSelected.fieldsSecondEntity = [];
        }

        if(annSelected.fieldsSecondEntity.length == 0){
            annSelected.fieldsSecondEntity.push(field.code);
        }
        else{
            annSelected.fieldsSecondEntity[0] =field.code;
        }

        return annSelected;
    }

    function setSecondFieldsSecond(field:Field){
        if(annotationsToSave.length > 0){
            if(!annotation.isUniqueMode){
                annotationsToSave.forEach(annSelected => {
                    annSelected = setSecondEntitySecondFieldData(annSelected, field);
                });
                updateBulkAnnotations(annotationsToSave);
            }
            else{
                var annnotationToUpdate = getDuplicateUniquesAnnotations(annotationsToSave,annotation);

                if(annnotationToUpdate.length > 0)
                {
                    annnotationToUpdate.forEach(annSelected => {
                        annSelected = setSecondEntitySecondFieldData(annSelected, field);
                    });
                    updateBulkAnnotations(annnotationToUpdate);
                }
            }   
        }
    }

    function setSecondEntitySecondFieldData(annSelected:Annotation, field:Field):Annotation{
        if(!annSelected.fieldsSecondEntity)
        {
            annSelected.fieldsSecondEntity = [];
        }

        if(annSelected.fieldsSecondEntity.length < 2){
            annSelected.fieldsSecondEntity.push(field.code);
        }
        else{
            annSelected.fieldsSecondEntity[1] =field.code;
        }

        return annSelected;
    }
    function updateBulkAnnotations(annotations:Annotation[])
    {
        
        var result = _annotationsService.updateBulk(annotations);
        result.then(result => {
            updateDocumentStats();
            //_annotationsService.executeFieldCounter(annotation.documentId);
            refreshData();
            //comunicar con el componente de anotador
        });
    }

    function ValidateFields(fieldIndex:number, fields:String[]):boolean{

        var result:boolean = true;
        if(fieldIndex == 1 && fields.length == 0){
            result = false;
        }
        return result;
    }

    function deleteField(fieldIndex:number){
        if(annotationsToSave.length > 0){
            if(!annotation.isUniqueMode){
                annotationsToSave.forEach(annSelected => {
                    if(fieldSelected == 0 && annSelected.fieldsFirstEntity)
                    {
                        annSelected.fieldsFirstEntity = annSelected.fieldsFirstEntity.filter((fieldItem, index) => fieldIndex !== index);
                    }
                    else if (fieldSelected ==  1 && annSelected.fieldsSecondEntity){
                        annSelected.fieldsSecondEntity = annSelected.fieldsSecondEntity.filter((fieldItem, index) => fieldIndex !== index);
                    }
                });
                updateBulkAnnotations(annotationsToSave);
            }
            else{
                var annnotationToUpdate = getDuplicateUniquesAnnotations(annotationsToSave,annotation);

                if(annnotationToUpdate.length > 0)
                {
                    annnotationToUpdate.forEach(annSelected => {
                        if(fieldSelected == 0 && annSelected.fieldsFirstEntity)
                        {
                            annSelected.fieldsFirstEntity = annSelected.fieldsFirstEntity.filter((fieldItem, index) => fieldIndex !== index);
                        }
                        else if (fieldSelected ==  1 && annSelected.fieldsSecondEntity){
                            annSelected.fieldsSecondEntity = annSelected.fieldsSecondEntity.filter((fieldItem, index) => fieldIndex !== index);
                        }
                    });
                    updateBulkAnnotations(annnotationToUpdate);
                }
            }

        }
    }

    function filterSelectedField(annotation:Annotation, fieldList: Field[]):Field[]{
        var arrayFields: String[] = [];
        if(entityId === annotation.firstEntityId && annotation.fieldsFirstEntity){
            arrayFields = annotation.fieldsFirstEntity;
        }else if (entityId === annotation.secondEntityId && annotation.fieldsSecondEntity){
            arrayFields = annotation.fieldsSecondEntity;
        }


        return fieldList.filter((field) => !arrayFields.includes(field.code));
    }

    function handleFieldDeleted(field:Field, fieldIndex:number){
        annotationsToSave = [];
        annotationsToSave = filterAnnotationsToSave(annotationList);

        deleteField(fieldIndex);
    }


    function handleFieldSelected(field:Field, fieldIndex:number){
        annotationsToSave = [];
        annotationsToSave = filterAnnotationsToSave(annotationList);
        
        if(fieldIndex == 0 && fieldSelected == 0 && ValidateFields(fieldIndex, annotation.fieldsFirstEntity!)){
            setFirstFieldsToAnnotations(field);
        }
        else if(fieldIndex == 1 && fieldSelected == 0  && ValidateFields(fieldIndex, annotation.fieldsFirstEntity!)){
            setSecondFieldsToAnnotations(field);
        }

        else if(fieldIndex == 0 && fieldSelected == 1 && ValidateFields(fieldIndex, annotation.fieldsSecondEntity!)){
            setFirstFieldsSecond(field);
        }
        else if(fieldIndex == 1 && fieldSelected == 1  && ValidateFields(fieldIndex, annotation.fieldsSecondEntity!)){
            setSecondFieldsSecond(field);
        }
        else {
            alert('Asegurese de tener un primer field antes de agregar el segundo');
        }

        //closeContextMenu();
    }
    
    return (
        
        <ul className="context-submenu-field">
            <div className="context-menu-container-options">
            {
                
                getEntityFields(entityId).map((field) => {

                    if(field.name !== 'Without Fields'){

                    return (
                    <li 
                    className="context-submenu-field-item"
                    onClick={(e) => {e.stopPropagation(); handleFieldSelected(field,fieldIndex);}}
                    >
                        <span>{field.name}</span>

                    </li>)
                    }else
                    {
                        return (
                            <li 
                            className="context-submenu-field-item"
                            onClick={(e) => {e.stopPropagation(); handleFieldDeleted(field,fieldIndex);}}
                            >
                                <span>Clear Field<DeleteForeverOutlined className="context-menu-item-icon"></DeleteForeverOutlined></span>
        
                            </li>)
                    }
                })
        
            }
            </div>
        </ul>
    )
}

export default ContextMenu_EntityFields

